import React from 'react'
import styled from 'styled-components'
import * as FaIcons from "react-icons/fa6";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setCheckInformationText, showRegisterModal } from '../../features/register/registerSlice';

const Container = styled.div`
   display: flex;
   flex-direction: column;
   gap: 10px;
   .check-container{
    display: flex;
    flex-direction: column;
        .error{
            font-size: var(--font-size-sm);
            color: var(--color-main);
            margin-top: 5px;
        }
        .row{
            display: flex;
            align-items: center;
            gap: 15px;
            .check{
                min-width: 20px;
                min-height: 20px;
                border: 1px solid black;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            p{
                font-size: var(--font-size-sm);
                span{
                    color: var(--color-main);
                    text-decoration: underline;
                    cursor: pointer;
                    font-weight: var(--font-weight-lg);
                }
            }
        }
   }
`

const InformationText = ({isSubmit}) => {
    const dispatch = useDispatch()
    const {checkInformationText} = useSelector((state) => state.register)
    const {acikRizaMetni, aydinlatmaMetni, uyelikSozlesmesi} = checkInformationText

  return (
    <Container>
        <div className='check-container'>
        <div className="row">
            <div onClick={() => dispatch(setCheckInformationText({uyelikSozlesmesi: !uyelikSozlesmesi}))} className="check">
                {
                    uyelikSozlesmesi === true && <FaIcons.FaCheck />
                }
            </div>
            <p><span onClick={() => dispatch(showRegisterModal("uyelikSozlesmesi"))} >Üyelik Sözleşmesini</span> okudum, onaylıyorum.</p>
        </div>
            
            {
                isSubmit && !uyelikSozlesmesi &&
                <p className='error'>Üyelik sözleşmesini kabul etmelisiniz.</p>
            }
        </div>

        <div className='check-container'>
            <div className='row'>
                <div onClick={() => dispatch(setCheckInformationText({aydinlatmaMetni: !aydinlatmaMetni}))} className="check">
                    {
                        aydinlatmaMetni === true && <FaIcons.FaCheck />
                    }
                </div>
                <p><span onClick={() => dispatch(showRegisterModal("aydinlatmaMetni"))} >KVKK Aydınlatma Metnini</span> okudum, anladım, kabul ediyorum.</p>
            </div>
            {
                isSubmit && !aydinlatmaMetni &&
                <p className='error'>KVKK Aydınlatma Metnini kabul etmelisiniz.</p>
            }
        </div>
        
        <div className='check-container'>
            <div className="row">
                <div onClick={() => dispatch(setCheckInformationText({acikRizaMetni: !acikRizaMetni}))} className="check">
                    {
                        acikRizaMetni === true && <FaIcons.FaCheck />
                    }
                </div>
                <p><span onClick={() => dispatch(showRegisterModal("acikRizaMetni"))} >KVKK Açık Rıza Metnini</span> okudum, anladım, kabul ediyorum. Ve kişisel verilerimin paylaşılmasına açık rıza veriyorum.</p>
            </div>
            
            {
                isSubmit && !acikRizaMetni &&
                <p className='error'>KVKK Açık Rıza Metnini kabul etmelisiniz.</p>
            }
        </div>
    </Container>
  )
}

export default InformationText